// extracted by mini-css-extract-plugin
export var base = "_4g-0";
export var updateBanner = "_4g-1";